import { Construtor } from './construtor';
import { ResultadoIndicador } from './resultado-indicador';

export class ResultadoDashboardSingle implements Construtor<ResultadoDashboardSingle> {

  public nomeIndicador: string;
  public nomePontoFisico: string;
  public resultados: ResultadoIndicador[];
  public chartData: any[];

  constructor(object?: any) {
    this.resultados = new Array<ResultadoIndicador>();
    this.chartData = new Array<any>();
    if (object !== undefined) {
      if (object instanceof (ResultadoDashboardSingle)) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }
  }

  parseFromJson(resultadoDashboard: any): void {
    this.nomeIndicador = resultadoDashboard.nomeIndicador;
    this.nomePontoFisico = resultadoDashboard.nomePontoFisico;
    this.resultados = resultadoDashboard.resultados;
  }

  copyObject(resultadoDashboard: ResultadoDashboardSingle): void {
    this.nomeIndicador = resultadoDashboard.nomeIndicador;
    this.nomePontoFisico = resultadoDashboard.nomePontoFisico;
    this.resultados = resultadoDashboard.resultados;
  }

  modeloCompleto(): boolean {
    return this.nomeIndicador !== undefined && this.nomePontoFisico !== undefined;
  }

  getNewInstance(object?: any): ResultadoDashboardSingle {
    return new ResultadoDashboardSingle(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/resultado-dashboard-single.ts